import { type DeviceAlarmSettings, DeviceType, type LoraStatus } from '../../api/device-api-types'

export interface MeterState {
  meterInEditor: Meter | null
  history: {
    fetchingHistoryGraphData: boolean
    historyGraphData: AllHistoryGraphData
  }
}

interface AllHistoryGraphData {
  water: UsageData
  temperature: UsageData
}

export interface UsageData {
  labels: string[]
  datasets: UsageDataDatasetEntry[]
}

export interface UsageDataDatasetEntry {
  label: string
  backgroundColor: string
  borderRadius: number
  borderSkipped: 'start' | 'end' | 'left' | 'right' | 'bottom' | 'top' | 'middle' | boolean
  barPercentage: number
  fill?: boolean
  data: number[]
}

export interface Meter {
  id: string
  companyId: string
  alarmSettings?: DeviceAlarmSettings
  baseValue?: number
  deleted: boolean
  devEui: string
  firstMeterDataEntry?: number
  flowLimitAlertActive: boolean
  labels: string[]
  latestLoraStatus?: LoraStatus
  leakageWarningActive: boolean
  location?: string
  pulseInLiters?: number
  sendTemperature: boolean
  serialNumber?: string
  temperatureAlertActive: boolean
  transmitterSerialNumber?: string
  type: DeviceType
  updatedAt?: number
  waterUsed?: number
}

export interface UpdateMeterRequest {
  meterId: string
  baseValue?: number
  serialNumber?: string
  pulseInLiters?: number
  transmitterSerialNumber?: string
  location?: string
  alarmSettings: DeviceAlarmSettings
  labels: string[]
}

export type MeterDataScale = 'single' | 'day' | 'week' | 'month'

export interface MetersReceivedPayload {
  meters: Meter[]
}

export interface FetchMeterHistoryValuesPayload {
  id: string
  start: number
  end: number
  scale: MeterDataScale
}

export interface MeterHistoryValue {
  id: string
  time: number
  temperature?: number
  waterUsed?: number
}

export interface FetchMeterHistoryValuesSuccessPayload {
  data: MeterHistoryValue[]
  scale: MeterDataScale
}

/**
 * * Function that checks whether the consumption of the meter is calculated from pulses and pulse size.
 */
export const isPulseDevice = (deviceType: DeviceType): boolean => {
  return deviceType === DeviceType.ADEUNIS ||
        deviceType === DeviceType.ADEUNIS_v3 ||
        deviceType === DeviceType.BMETERS_LORA_PULSE
}
